function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Represents the order form fields, in this way we can retrieve the value of the fields and manipulate their format
 * Notice that it basically reads from section-one, and writes to section-two, maintaining consistency between both
 * @private
 */
var OrderForm = /*#__PURE__*/function () {
  /**
   * @param {array} inputFields Array containing the input field HTMLNode elements
   */
  function OrderForm(inputFields) {
    _classCallCheck(this, OrderForm);
    this.inputFields = inputFields;
  }

  /**
   * Add an extra field to be part of the Order Form field
   * @param field HTMLNode element
   */
  return _createClass(OrderForm, [{
    key: "addField",
    value: function addField(field) {
      this.inputFields.push(field);
    }

    /**
     * Get the form field values
     *
     * @param {boolean} parentClass Default to false, where the key will be the current field attribute 'name'.
     *                              Pass true if you want the key to be the parent class. (Backend format)
     * @returns {{}} Returns the current status of the fields, as a key value object
     */
  }, {
    key: "getFieldsValues",
    value: function getFieldsValues() {
      var parentClass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var result = {};
      this.inputFields.forEach(function (field) {
        var index = parentClass ? field.parentNode.classList[0] : field.getAttribute('name');
        result[index] = field.value;
      });
      return result;
    }

    /**
     * Validates the form fields using their HTML5 attributes. Adds the class @errorClass if the fields are not valid
     *
     * @param {string} errorClass Class to be added if the field is invalid
     * @returns {boolean} Returns true if ALL fields are valid. Otherwise false
     */
  }, {
    key: "validateFields",
    value: function validateFields() {
      var errorClass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'error';
      // NOTE: Add extra validations when required
      var validity = true;
      this.inputFields.forEach(function (field) {
        field.classList.remove(errorClass);
        if (field.validity.valid !== true) {
          validity = false;
          field.classList.add(errorClass);

          // Triggers field validation - supports IE as well
          if (!HTMLFormElement.prototype.reportValidity) {
            HTMLFormElement.prototype.reportValidity = function () {
              return;
            };
          }
        }
      });
      return validity;
    }
  }]);
}();
export default OrderForm;